module.exports = __webpack_public_path__ + "static/media/pm.f8518355.png";